module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-5.4fd73e3d.png";